import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Checkbox,
  FormControlLabel,
  Button,
  Slide,
  Card,
  CardContent,
  DialogActions,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { getToken, getAclMenu } from '../../../utils/common';
import { message, notification } from 'antd';

const { de } = require('date-fns/locale');
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function DialogCalendar(props) {
  const { t } = useTranslation();

  function handleClickLang(lang) {
    i18next.changeLanguage(lang);
  }
  const { open, data, handleClose, date, refresh } = props;
  const [acl, setAcl] = useState(getAclMenu('calendar'));
  const fetchInfo = (url) => {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify({ id: selectedItems }),
    })
      .then((res) => res.json())
      .then((d) => {
        notification.success({
          message:  'Success',  
          description: t('CalendarPrompt.5'),
          placement: 'top', 
          duration: 0, 
          
        }),
        refresh();
        handleClose();
      });
  };
  const handleDeleteSelected = () => {
    fetchInfo(window.REACT_APP_API_PURE + 'calendar/deletecalendar');
  };
  const handleCheckboxChange = (itemId) => {
    setSelectedItems((prevSelected) => {
      if (prevSelected.includes(itemId)) {
        // If the item is already selected, remove it
        return prevSelected.filter((id) => id !== itemId);
      } else {
        // If the item is not selected, add it
        return [...prevSelected, itemId];
      }
    });
  };
  const [selectedItems, setSelectedItems] = useState([]);
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
      fullWidth={true}
      maxWidth={'md'}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        {t('CalendarPrompt.1')} {date}
      </DialogTitle>
      <DialogContent>
        {' '}
        {data
          .filter((item, index, self) => self.findIndex((t) => t.id === item.id) === index)
          .map((item) => (
            <Card key={item.id} variant="outlined" style={{ marginBottom: 10, maxHeight: '100px' }}>
              <CardContent>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={!acl?.delete}
                      checked={selectedItems.includes(item.id)}
                      onChange={() => handleCheckboxChange(item.id)}
                      color="primary"
                    />
                  }
                  label={`${item.title}`}
                />

                <Typography variant="body2" color="textSecondary">
                  {item.schedule} {new Date(item.time_start).toLocaleString('en-ID', { timeZone: 'GMT' })}
                </Typography>
              </CardContent>
            </Card>
          ))}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose} style={{ color: 'red' }}>
          {!acl?.delete ? t('CalendarPrompt.2') : t('CalendarPrompt.3')}
        </Button>

        {!acl?.delete ? (
          ''
        ) : (
          <Button
            style={{ color: 'white', backgroundColor: '#1eb3d9', disabled: !selectedItems.length, opacity: selectedItems.length ? 1 : 0.5 }}
            onClick={handleDeleteSelected}
            disabled={!selectedItems.length}
          >
            {t('CalendarPrompt.4')}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
